import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    loading: false,
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    //form specific:
    entityInterfaceData: {},

    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    entityInterfaceWasCreated: false,
    entityInterfaceWasEdited: false,
    entityInterfaceWasDeleted: false,

    error: undefined,

    loadingCategories: false,
    categoryList: []
};

const entityInterfaceReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.ENTITY_INTERFACE_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.ENTITY_INTERFACE_SEARCH_SUCCESS:
            return {
                ...state,
                loading:false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.ENTITY_INTERFACE_SEARCH_FAILED:
            return {
                ...state,
                loading:true
            };
        case actionTypes.GET_ENTITY_INTERFACE_REQUEST:
            return {
                ...state,
                loading:true,
            };
        case actionTypes.GET_ENTITY_INTERFACE_SUCCESS:
            return {
                ...state,
                loading: false,
                entityInterfaceData: payload,
            };
        case actionTypes.GET_ENTITY_INTERFACE_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.DELETE_ENTITY_INTERFACE_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_ENTITY_INTERFACE_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                entityInterfaceWasDeleted: true
            };
        case actionTypes.DELETE_ENTITY_INTERFACE_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                entityInterfaceWasDeleted: false
            };
        case actionTypes.EDIT_ENTITY_INTERFACE_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_ENTITY_INTERFACE_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                entityInterfaceWasEdited: true
            };
        case actionTypes.EDIT_ENTITY_INTERFACE_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                entityInterfaceWasEdited: false
            };
        case actionTypes.CREATE_ENTITY_INTERFACE_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_ENTITY_INTERFACE_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                entityInterfaceWasCreated: true
            };
        case actionTypes.CREATE_ENTITY_INTERFACE_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                entityInterfaceWasCreated: false
            };
        case actionTypes.RESET_ENTITY_INTERFACE_FORM:
            return {
                ...state,
                entityInterfaceData: {},
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                entityInterfaceWasCreated: false,
                entityInterfaceWasEdited: false,
                entityInterfaceWasDeleted: false,
                error: undefined
            };
        default:
            return state;
    }
};

export default entityInterfaceReducer;